"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SilverbackIframe = void 0;
const iframe_resizer_react_1 = __importDefault(require("iframe-resizer-react"));
const react_1 = __importStar(require("react"));
const iframe_command_1 = require("../types/iframe-command");
const SilverbackIframe = (_a) => {
    var { buildMessages, redirect } = _a, iframeResizerProps = __rest(_a, ["buildMessages", "redirect"]);
    const iframeRef = (0, react_1.useRef)(null);
    const [iframeSeed, setIframeSeed] = (0, react_1.useState)(null);
    const [currentCommand, setCurrentCommand] = (0, react_1.useState)();
    return (react_1.default.createElement("div", { className: "silverback-iframe" },
        react_1.default.createElement("div", { className: "silverback-iframe-messages" }, ((currentCommand === null || currentCommand === void 0 ? void 0 : currentCommand.action) === 'displayMessages' ||
            (currentCommand === null || currentCommand === void 0 ? void 0 : currentCommand.action) === 'replaceWithMessages') &&
            buildMessages(currentCommand.messages)),
        (currentCommand === null || currentCommand === void 0 ? void 0 : currentCommand.action) !== 'replaceWithMessages' && (react_1.default.createElement(iframe_resizer_react_1.default, Object.assign({}, iframeResizerProps, { forwardRef: iframeRef, src: iframeResizerProps.src &&
                updateUrlParameters(iframeResizerProps.src, {
                    iframe: 'true',
                    iframeSeed: iframeSeed,
                }), onMessage: ({ message }) => {
                var _a;
                if (!(0, iframe_command_1.isIframeCommand)(message)) {
                    return;
                }
                if (message.action === 'getBaseUrl') {
                    (_a = iframeRef.current) === null || _a === void 0 ? void 0 : _a.sendMessage(`silverback-iframe-base-url:${window.location.origin}`, '*');
                    return;
                }
                if (message.action === 'redirect') {
                    redirect(message.path, message.messages);
                    // In case if redirect path is the same with the current path,
                    // the redirect() call may do nothing (Gatsby case). Here we
                    // change the URL of the iframe (and update the iframe contents)
                    // to imitate a redirect to the same page.
                    setIframeSeed(Date.now().toString());
                }
                else {
                    setCurrentCommand(message);
                }
            } })))));
};
exports.SilverbackIframe = SilverbackIframe;
const updateUrlParameters = (uri, parameters) => {
    let result = uri;
    Object.entries(parameters).forEach(([key, value]) => {
        result = updateUrlParameter(result, key, value);
    });
    return result;
};
// From https://gist.github.com/niyazpk/f8ac616f181f6042d1e0#gistcomment-3797774
const updateUrlParameter = (uri, key, value) => {
    // remove the hash part before operating on the uri
    const i = uri.indexOf('#');
    const hash = i === -1 ? '' : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);
    const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (value === null) {
        // remove key-value pair if value is specifically null
        uri = uri.replace(new RegExp(`([?&]?)${key}=[^&]*`, 'i'), '');
        if (uri.slice(-1) === '?') {
            uri = uri.slice(0, -1);
        }
        // replace first occurrence of & by ? if no ? is present
        if (uri.indexOf('?') === -1)
            uri = uri.replace(/&/, '?');
    }
    else if (uri.match(re)) {
        uri = uri.replace(re, `$1${key}=${value}$2`);
    }
    else {
        uri = `${uri + separator + key}=${value}`;
    }
    return uri + hash;
};
